import { render, staticRenderFns } from "./MedicationDetail.vue?vue&type=template&id=647fd534&scoped=true"
import script from "./MedicationDetail.vue?vue&type=script&lang=js"
export * from "./MedicationDetail.vue?vue&type=script&lang=js"
import style0 from "./MedicationDetail.vue?vue&type=style&index=0&id=647fd534&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647fd534",
  null
  
)

export default component.exports